import { Component, Element, h, Host, Prop } from '@stencil/core';
import {
  PARAGRAPH_ALIGNMENTS,
  PARAGRAPH_APPEARANCES,
  PARAGRAPH_SIZES,
  ParagraphAlignment,
  ParagraphAppearance,
  ParagraphColors,
  ParagraphSize,
} from './models/paragraph.types';

@Component({
  tag: 'wink-paragraph',
  styleUrl: 'styles/paragraph.default.scss',
  shadow: true,
})
export class Paragraph {
  @Element() host!: HTMLWinkParagraphElement;

  @Prop() appearance: ParagraphAppearance = PARAGRAPH_APPEARANCES.body;
  @Prop() size: ParagraphSize = PARAGRAPH_SIZES.regular;
  @Prop() alignment: ParagraphAlignment = PARAGRAPH_ALIGNMENTS.left;
  @Prop() paragraphColor?: ParagraphColors;
  @Prop() isBold = false;
  @Prop() isFlowRendition = false;
  @Prop() isTextTruncated = false;

  render() {
    return (
      <Host>
        <p
          class={{
            [this.isBold ? 'font--bold' : '']: true,
            ['font--' + this.appearance + (this.size && '-') + this.size]: true,
            ['color--' + this.paragraphColor]: this.paragraphColor !== undefined,
            [this.isTextTruncated ? 'ellipsis' : '']: true,
          }}>
          <slot />
        </p>
      </Host>
    );
  }
}
